module.exports = __webpack_public_path__ + "img/concept-jeu.c59336fa.jpg";